import type { TefComsCancelButton } from '@mfe/components/TefComsCancelButton';
import { html } from 'lit';

// a cancel button that triggers an event
export const tefComsCancelButton = function render(this: TefComsCancelButton) : ReturnType<typeof html> {
  return html`
    <one-button variant="outline" @click=${this.handleClick}>
      <one-icon name="chevron-left"></one-icon>
      ${this.text}
    </one-button>
  `;
};
